(function() {
  let counter = 0;
  const new_link_url = typeof alternateLinks !== 'undefined' && alternateLinks.fr ? alternateLinks.fr : '';
  const URL = "https://fr.roble.store";
  const Text1 = 'FR';
  const Text2 = 'Français';
  const CODE = 'fr';



  document.addEventListener('DOMContentLoaded', function() {
    const alternate_fr = document.querySelectorAll('link[rel="alternate"][hreflang="fr"]');

    alternate_fr.forEach(function(link) {
      link.href = new_link_url;
    });
  });

  if (!Weglot) return;

  Weglot.on('switchersReady', onSwitchersReady);

  const makeFrLink = (wrapper) => {
    let from = 'en';
    if (counter > 3) {
      return null;
    }
    let templateEn = wrapper.querySelector(`#weglot-listbox #wg-${from}`);
    if (!templateEn) {
      from = 'es';
      templateEn = wrapper.querySelector(`#weglot-listbox #wg-${from}`);
      if (!templateEn) {
        return null;
      }
    }

    const templateFr = templateEn.cloneNode();
    const enAttributes = templateEn.attributes;
    for (var i = enAttributes.length - 1; i >= 0; i--) {
      const name = enAttributes[i].name;
      const value = enAttributes[i].value;
      if (value.includes(from)) {
        templateFr.setAttribute(name, value.replace(from, CODE));
      }
    }

    const html = templateEn.innerHTML
      .replace(/(en|gb|es)/g, CODE)
      .replace('EN', Text1)
      .replace('ES', Text1)
      .replace('English', Text2)
      .replace('Español', Text2);
    templateFr.innerHTML = html;
    templateFr.querySelector(`#weglot-language-${CODE}`).href = URL;
    wrapper.querySelector('#weglot-listbox').prepend(templateFr);
    counter++;
    return wrapper.querySelector(`#weglot-language-${CODE}`)
  }

  function getLinkInSwitcher(weglotWrapper, lang = CODE) {
    if (!weglotWrapper) return null;
    const link = weglotWrapper.querySelector(`#weglot-language-${lang}`);

    if (link) {
      return link;
    }
    return makeFrLink(weglotWrapper);
  }

  // Because Weglot triggers the switchersReady event before the switchers are actually ready
  // we need to check if the switchers are contain links
  function onSwitchersReady() {
    const { switchers } = Weglot.options;
    if (!switchers) return;
    switchers.forEach(function(sw) {
      const selector = sw.location.target;

      const weglotWrapper = document.querySelector(selector);
      const weglot_link_fr = getLinkInSwitcher(weglotWrapper, 'fr');
      if (weglot_link_fr) {
        replaceSwitchersLink(weglot_link_fr, new_link_url);
      } else {
        const switcher_observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              const weglot_link_fr = getLinkInSwitcher(weglotWrapper, 'fr');
              replaceSwitchersLink(weglot_link_fr, new_link_url);
              switcher_observer.disconnect();
            }
          });
        });

        switcher_observer.observe(weglotWrapper, {
          childList: true,
          subtree: true
        });
      }
    });
  }

  function getFullPathLink(link) {
    return link ? (new_link_url + window.location.pathname).replace(/\/\//g, '/') : link;
  }

  function replaceSwitchersLink(link, new_link_url) {
    new_link_url = getFullPathLink(new_link_url);
    if (!link || !new_link_url) return;

    link.href = new_link_url;

    // Because Weglot switchers are loaded with empty href attribute and then updated
    // we need to observe the link to update it when it changes
    const link_observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
          if (mutation.target.href !== new_link_url) {
            mutation.target.href = new_link_url;
            link_observer.disconnect();
          }
        }
      });
    });

    link_observer.observe(link, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['href']
    });
  }
})();
